// extracted by mini-css-extract-plugin
export default {"caixona":"p7_caixona__dZmD-","caixa":"p7_caixa__gHjtF"};